import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const FileDoc = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      d="M4 2C2.89543 2 2 2.89543 2 4V20C2 21.1046 2.89543 22 4 22H16C17.1046 22 18 21.1046 18 20V17H16V20H4V4H16V7H18V4C18 2.89543 17.1046 2 16 2H4Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.85366 9.68518H6V14.3148H7.85366C9.41463 14.3148 10.4878 13.2963 10.4878 12C10.4878 10.7037 9.31707 9.68518 7.85366 9.68518ZM7.36585 10.7963H7.85366C8.63415 10.7963 9.21951 11.2593 9.21951 12C9.21951 12.7407 8.63415 13.2037 7.95122 13.2037H7.36585V10.7963Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.8049 14.5C15.3659 14.5 16.5366 13.2963 16.5366 12C16.5366 10.7037 15.3659 9.5 13.8049 9.5C12.2439 9.5 11.0732 10.6111 11.0732 12C11.0732 13.3889 12.2439 14.5 13.8049 14.5ZM13.8049 13.2963C13.0244 13.2963 12.439 12.7407 12.439 12C12.439 11.2593 13.0244 10.7037 13.8049 10.7037C14.5854 10.7037 15.1707 11.2593 15.1707 12C15.1707 12.7407 14.5854 13.2963 13.8049 13.2963Z"
      fill="currentColor"
    />
    <path
      d="M19.8537 13.2963C19.0732 13.2963 18.4878 12.7407 18.4878 12C18.4878 11.2593 19.0732 10.7037 19.8537 10.7037C20.6341 10.7037 21.122 11.2593 21.122 11.2593L21.9024 10.4259C21.9024 10.4259 21.2195 9.5 19.8537 9.5C18.2927 9.5 17.122 10.6111 17.122 12C17.122 13.3889 18.2927 14.5 19.8537 14.5C21.3171 14.5 22 13.5741 22 13.5741L21.2195 12.7407C21.2195 12.7407 20.7317 13.2963 19.8537 13.2963Z"
      fill="currentColor"
    />
  </Icon>
));

export default FileDoc;
